const academicYears = {
  Y2022_2023: 26,
  Y2023_2024: 27,
  Y2024_2025: 31,
  Y2025_2026: 32,
  Y2026_2027: 33
};

export default academicYears;
